import React from "react";

import { Remo } from "@components";
import { IDevice } from "@common/models";
import { styles, remoStyles } from "@common/styles";
import DeviceList from "./device-list";

export interface IDevicesProps {
  devices: IDevice[];
  userId: string;
}

export interface IDevicesActions {
  refreshDevices: () => void;
  removeDevice: (userId: string, deviceId: string) => void;
}

export interface IDevicesState {
  device: IDevice;
}

class Devices extends React.Component<
  IDevicesProps & IDevicesActions,
  IDevicesState
> {
  constructor(props) {
    super(props);

    this.state = {
      device: undefined
    };
  }

  componentDidMount() {
    this.props.refreshDevices();
  }

  public render() {
    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <div
          className="pageHeaderContainer"
          style={styles.pageHeaderContainer as any}
        >
          Håndter dine enheter
        </div>
        <DeviceList
          devices={this.props.devices}
          removeDevice={this.removeDeviceConfirm}
        />
        <Remo show={!!this.state.device}>
          <div style={remoStyles.container as any} className="flexList">
            <div style={remoStyles.header as any}>Advarsel</div>
            <div style={remoStyles.text as any}>
              Er du sikker på at du vil fjerne enheten
              {this.state.device ? this.state.device.deviceId : null}
              fra din bruker?
            </div>
            <div style={remoStyles.okButton as any} onClick={this.removeDevice}>
              Slett enhet
            </div>
            <div
              style={remoStyles.remoCancelButtonStyle as any}
              onClick={this.closeModal}
            >
              Avbryt
            </div>
          </div>
        </Remo>
      </div>
    );
  }

  private removeDeviceConfirm = device => {
    this.setState({ device });
  };

  private removeDevice = () => {
    const { device } = this.state;
    const { userId } = this.props;
    this.setState({ device: null }, () =>
      this.props.removeDevice(userId, device.deviceId)
    );
  };

  private closeModal = () => {
    this.setState({ device: null });
  };
}

export default Devices;
